import { get } from "lodash";
import { useMutation, useQuery } from "shared/hooks/useApi";
import graphql from "utils/api/graphql";
import { KEYS } from "utils/constants";
import Loading from "../Components/Spin";
import View from "./View";

const ElectronicSignature = ({ project, onNext, onBack, updateUrl }) => {
  const subscriptionId = get(project, "fields.currentSubscription");
  const { data, loading } = useQuery(graphql.queries.SUBSCRIPTION, {
    variables: { where: { id: subscriptionId } },
  });
  const [updateSubscription] = useMutation(
    graphql.mutations.UPDATE_SUBSCRIPTION,
    {
      variables: { where: { id: subscriptionId }, data: { locked: true } },
    },
  );

  const signatureLink = get(data, "subscription.signature.signatureLink");

  if (loading || !signatureLink) return <Loading />;

  const source = localStorage.getItem(KEYS.SOURCE);
  const next = (_ = {}) => {
    updateSubscription();
    updateUrl({
      subscriptionId,
      url: get(
        data,
        "subscription.insurancePlan.config.generatedUrl",
        `${process.env.REACT_APP_BASE_URL}/#/public/process/init/${source}`,
      ),
    });
    onNext({ payload: {} });
  };

  return (
    <View
      onNext={next}
      user={get(project, "contact.user")}
      onBack={onBack}
      signatureLink={signatureLink}
    />
  );
};

export default ElectronicSignature;
